import React from 'react';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import MerchantForm from "@/Pages/Merchants/Assets/MerchantForm";
import LoadingButton from "@/Shared/LoadingButton";
import Layout from "@/Shared/Layout";
import DeleteButton from '@/Shared/DeleteButton';
import { Inertia } from '@inertiajs/inertia';

const Edit = () => {
  const {categories, merchant, merchant_categories} = usePage().props;
  const {data, setData, errors, post, processing} = useForm({
    merchant_name: merchant.merchant_name || "",
    short_description: merchant.short_description || "",
    description: merchant.description || "",
    homepage_url: merchant.homepage_url || "",
    merchant_link_url: merchant.merchant_link_url || "",
    def_image_logo: "",
    keywords: merchant.keywords || "",
    merchant_sort_name: merchant.merchant_sort_name || "",
    merchant_text_linkname: merchant.merchant_text_linkname || "",
    category_id: merchant_categories ? merchant_categories.map(item => item.category_id) : [],
    showonline: !!merchant.showonline || "",
    txtCouponName: merchant.txtCouponName || "",
    txtCouponPlace: merchant.txtCouponPlace || "",
    internal_notes: merchant.internal_notes || "",
    relative_uri: merchant.relative_uri || "",
    intNetworkID: merchant.intNetworkID || 0,
    intAdvertiserID: merchant.intAdvertiserID || 0,
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('added.merchants.update', merchant.merchant_id).url());
  }

  function destroy() {
    if (confirm('Are you sure you want to delete this merchant?')) {
      Inertia.delete(route('added.merchants.destroy', merchant.merchant_id));
    }
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.merchants')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Merchants
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <MerchantForm categories={categories} errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-between px-8 py-4 bg-gray-100 border-t border-gray-200">
            <DeleteButton onDelete={destroy}>Delete Merchant</DeleteButton>
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Merchant
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit merchant" children={page}/>;
export default Edit;
